import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/jmd',
  name: 'jmd',
  meta: {
      title: '聚梦达面试登记表'
  },
  component: HomeView
}, {
  path: '/jddj',
  name: 'jddj',
  meta: {
      title: '剧点面试登记表'
  },
  component: HomeView
}, {
  path: '/hpr',
  name: 'hpr',
  meta: {
      title: '杭漂人面试登记表'
  },
  component: HomeView
}, {
  path: '/policy',
  name: 'policy',
  meta: {
      title: '隐私政策'
  },
  component: () => import('../views/policy.vue')
}]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router